import HomeContainer from "../HomeContainer/HomeContainer";
import BannerItem from "./BannerItem";
import "./PromotionalBanners.css";

export default function PromotionalBanners({
  banners = [],

  columns = 2,

  container = true,

  className = "",
}) {
  //  console.log("banners", banners);

  if (!banners.length) {
    return null;
  }

  const content = (
    <section className={`home-banners ${className}`}>
      <div className={`home-banners__grid home-banners__grid--${columns}`}>
        {banners.map((banner) => (
          <BannerItem key={banner.id} banner={banner} />
        ))}
      </div>
    </section>
  );

  if (!container) {
    return content;
  }

  return <HomeContainer>{content}</HomeContainer>;
}
